import sanitizeHtml from "sanitize-html";

export const stringUtil = {
  prepareDangerousHTML: (html) => {
    if (typeof html !== "string" || html.trim() === "") return "";

    return sanitizeHtml(html, {
      disallowedTagsMode: "discard",
      allowedTags: [
        "strong",
        "b",
        "em",
        "i",
        "u",
        "s",
        "sub",
        "sup",
        "br",
        "a",
        "p",
        "ul",
        "ol",
        "li",
      ],
      allowedAttributes: {
        a: ["href", "target", "rel"],
      },
      allowedSchemesByTag: {
        a: ["https"],
      },
    });
  },

  toBase64: (str) => {
    return btoa(String.fromCharCode(...new TextEncoder().encode(str)));
  },

  fromBase64: (base64) => {
    return new TextDecoder().decode(
      Uint8Array.from(atob(base64), (c) => c.charCodeAt(0)),
    );
  },
};
